import type { StructureBinding } from "../api/rest";

const COLUMNS: (keyof StructureBinding)[] = ["address", "zone", "aisle", "rack", "level", "space", "purpose"];

/**
 * ADR 174, slice S9: the location→Space binding as iC3's semicolon-CSV — one row per bound
 * address, structure-aware columns keyed on the address iC3 already has. Null tiers become empty
 * cells. This is the offline-first enrichment file iC3 joins on its address key.
 */
export function bindingsToIc3Csv(bindings: StructureBinding[]): string {
  const rows = bindings.map((b) => COLUMNS.map((c) => csvCell(b[c])).join(";"));
  return [COLUMNS.join(";"), ...rows].join("\n");
}

/** Empty for null; quote-wraps (RFC-4180 style) only when the value carries a separator. */
function csvCell(v: string | null): string {
  if (v == null) return "";
  return /[;"\n]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v;
}
